import Grid2 from '@mui/material/Unstable_Grid2';

import { HighlightIconCardContent } from '@/components/HighlightIconStat/HighlightIconStat';
import Icon from '@/components/Icon/Icon';
import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import useGlobalStyles from '@/styles/global.styles';
import { brandColors } from '@/styles/sunrunTheme.styles';

import useStyles from './IconList.styles';

interface TextListProps {
  list: HighlightIconCardContent[] | undefined;
  isOnDark?: boolean | undefined;
}

export default function IconList({ list, isOnDark }: TextListProps) {
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const { classes, cx } = useStyles({ isOnDark });

  const IconListItem = ({ item }: { item: HighlightIconCardContent }) => {
    const { icon, cardTitle, subTitle } = item.fields;
    return (
      <Grid2 xs={6} sm={4} className={classes.item}>
        <div>
          <Icon
            name={icon.fields.name || ''}
            color={isOnDark ? brandColors.white : brandColors.black}
            width={56}
          />
          <p className={cx(globalClasses.h4, classes.itemHeading)}>
            {cardTitle}
          </p>
          <p className={cx(globalClasses.body, classes.itemBody)}>{subTitle}</p>
        </div>
      </Grid2>
    );
  };

  return (
    <GridContainer2 fixed gridProps={{ className: classes.IconListRow }}>
      {list &&
        list.map((item, index) => (
          <IconListItem key={`icon-list-item-${index}`} item={item} />
        ))}
    </GridContainer2>
  );
}
